var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1838_23229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0026 5.41667C13.1609 5.41667 15.9776 7.19167 17.3526 10C15.9776 12.8083 13.1693 14.5833 10.0026 14.5833C6.83594 14.5833 4.0276 12.8083 2.6526 10C4.0276 7.19167 6.84427 5.41667 10.0026 5.41667ZM10.0026 3.75C5.83594 3.75 2.2776 6.34167 0.835938 10C2.2776 13.6583 5.83594 16.25 10.0026 16.25C14.1693 16.25 17.7276 13.6583 19.1693 10C17.7276 6.34167 14.1693 3.75 10.0026 3.75ZM10.0026 7.91667C11.1526 7.91667 12.0859 8.85 12.0859 10C12.0859 11.15 11.1526 12.0833 10.0026 12.0833C8.8526 12.0833 7.91927 11.15 7.91927 10C7.91927 8.85 8.8526 7.91667 10.0026 7.91667ZM10.0026 6.25C7.93594 6.25 6.2526 7.93333 6.2526 10C6.2526 12.0667 7.93594 13.75 10.0026 13.75C12.0693 13.75 13.7526 12.0667 13.7526 10C13.7526 7.93333 12.0693 6.25 10.0026 6.25Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1838_23229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.044fb1c1533c7a05089818b290907ab0.svg";
export { ForwardRef as ReactComponent };